import { Component } from '@angular/core';


@Component({
  selector: 'app-abuse-policy',
  standalone: true,
  imports: [],
  templateUrl: './abuse-policy.component.html',
  styleUrl: './abuse-policy.component.scss'
})
export class AbusePolicyComponent {

}
